<template>
    <b-tabs
        justified
        small
        nav-wrapper-class="my-1"
        active-nav-item-class="bg-primary text-white"
    >
        <b-tab
            v-for="career in careerList"
            :key="career"
            :title="career"
            :active="career == adminPageActiveCareer"
            @click="setAdminActiveCareer(career)"
        />
    </b-tabs>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    name: 'AdminCoursesListCareerSelector',
    computed: {
        ...mapState([
            'careerList',
            'adminPageActiveCareer'
        ])
    },
    methods: mapActions([
        'setAdminActiveCareer'
    ])
}
</script>
